import { render, staticRenderFns } from "./SeverityBoxes.vue?vue&type=template&id=309fab32&scoped=true"
import script from "./SeverityBoxes.vue?vue&type=script&lang=js"
export * from "./SeverityBoxes.vue?vue&type=script&lang=js"
import style0 from "./SeverityBoxes.vue?vue&type=style&index=0&id=309fab32&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309fab32",
  null
  
)

export default component.exports